import TyreBarcodeScannerBaseController from "./tyre_barcode_scanner_base_controller"

export default class extends TyreBarcodeScannerBaseController {
  static targets = [
    ...TyreBarcodeScannerBaseController.targets,
    "itemFoundAlert",
    "itemFoundMessage",
    "itemFoundItems"
  ]
  static values = {
    ...TyreBarcodeScannerBaseController.values,
    ertId: String,
    tyreAlreadyFound: String,
    tyreMultipleFound: String
  }

  submitBarcode(event) {
    let fromScan = true
    if (event) {
      event.preventDefault()
      fromScan = false
    }

    const scannedBarcode = this.normalizedValue(this.inputTarget.value)
    if (!scannedBarcode) {
      return
    }

    const existingGarageItems = this.findMatchingGarageItems(scannedBarcode)

    if (existingGarageItems.length > 0) {
      this.showItemFoundAlert(existingGarageItems)
      return
    }

    this.openAddNewGarageItemModal(scannedBarcode, fromScan)
  }

  findMatchingGarageItems(scannedBarcode) {
    const list = document.querySelector(`#ert_${this.ertIdValue}`)

    if (!list) {
      return []
    }

    const items = list.querySelectorAll("[data-garage-item-id]")

    return Array.from(items).filter((item) => this.normalizedValue(item.dataset.garageItemBarcode) === scannedBarcode)
  }

  showItemFoundAlert(existingGarageItems) {
    this.inputTarget.value = ""

    this.itemFoundMessageTarget.textContent = existingGarageItems.length === 1 ? this.tyreAlreadyFoundValue : this.tyreMultipleFoundValue

    const table = document.createElement("table")
    table.classList.add("table", "garage_item_found_table")

    const tbody = document.createElement("tbody")
    table.appendChild(tbody)

    existingGarageItems.forEach((item) => {
      const itemClone = item.cloneNode(true)
      itemClone.removeAttribute("id")
      const selectCell = itemClone.querySelector(".garage_item_select_cell")
      if (selectCell) {
        selectCell.remove()
      }

      tbody.appendChild(itemClone)
    })

    // Replace previous matches when a tyre is scanned again.
    this.itemFoundItemsTarget.replaceChildren(table)

    // Use hidden to preserve the alert's flex layout when it is shown again.
    this.itemFoundAlertTarget.hidden = false
  }

  hideItemFoundAlert() {
    if (!this.hasItemFoundAlertTarget) {
      return
    }

    this.itemFoundMessageTarget.textContent = ""
    this.itemFoundItemsTarget.replaceChildren()
    this.itemFoundAlertTarget.hidden = true
  }
}
